<template>
  <div class="pager-box">
    <div class="total-pages">{{ value.totalLength }} results</div>
    <div class="pager">
      <Paginate
        v-model="page"
        :page-count="value.last"
        prev-text='<div class="pre-arrow"></div>'
        next-text='<div class="next-arrow"></div>'
        container-class="pagination">
      </Paginate>
    </div>
  </div>
</template>

<script lang="ts">
import { Pager } from '@/store/pager.types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import Paginate from 'vuejs-paginate'

@Component({
  components: {
    Paginate,
  },
})
export default class PagerComponent extends Vue {
  @Prop({ required: true }) value!: Pager

  private get page(): number {
    return this.value.current
  }

  private set page(page: number) {
    this.$emit('changePage', page)
  }
}
</script>

<style>
a {
  outline: none;
}

.pager-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.total-pages {
  font-size: 14px;
  margin-right: 50px;
}

.pager {
  text-align: right;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.pager ul.pagination {
  padding-inline-start: 0px;
  margin: auto;
}

.pager .pagination li {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  position: relative;
  text-align: center;
}

.pager .pagination a {
  text-decoration: none;
  position: absolute;
  color: #808080;
  width: 100%;
  height: 100%;
  transition: all  0.3s ease;
  left: 0;
}

.pager .pagination li.active a {
  text-decoration: none;
  position: absolute;
  font-size: 120%;
  color: #111111;
  width: 100%;
  height: 100%;
  transition: all  0.3s ease;
  left: 0;
}

.pager .pagination a:hover {
  color: #fff;
  background: #DDEAF6;
}

.pre-arrow {
  position: absolute;
  content: '';
  width: 6px;
  height: 6px;
  border: 0px;
  border-top: solid 2px #808080;
  border-left: solid 2px #808080;
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 50%;
  left: 50%;
  margin-top: -4px;
}

.next-arrow {
  position: absolute;
  content: '';
  width: 6px;
  height: 6px;
  border: 0px;
  border-top: solid 2px #808080;
  border-right: solid 2px #808080;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  top: 50%;
  right: 50%;
  margin-top: -4px;
}
</style>
